import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

interface Props {
  gameId: string
  id: string
}

const Screenshot: React.FC<Props> = ({ gameId, id, ...props }) => {
  const data = useStaticQuery(graphql`
    query {
      comiquest1: file(
        relativePath: { eq: "comiquest/screenshots/screen1.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 200) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      comiquest2: file(
        relativePath: { eq: "comiquest/screenshots/screen2.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 200) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      comiquest3: file(
        relativePath: { eq: "comiquest/screenshots/screen3.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 200) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      comiquest4: file(
        relativePath: { eq: "comiquest/screenshots/screen4.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 200) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      memoquest1: file(
        relativePath: { eq: "memoquest/screenshots/screen1.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 200) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      memoquest2: file(
        relativePath: { eq: "memoquest/screenshots/screen2.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 200) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      memoquest3: file(
        relativePath: { eq: "memoquest/screenshots/screen3.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 200) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      memoquest4: file(
        relativePath: { eq: "memoquest/screenshots/screen4.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 200) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      memoquest5: file(
        relativePath: { eq: "memoquest/screenshots/screen5.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 200) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      memoquest6: file(
        relativePath: { eq: "memoquest/screenshots/screen6.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 200) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      memoquest7: file(
        relativePath: { eq: "memoquest/screenshots/screen7.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 200) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      memoquest8: file(
        relativePath: { eq: "memoquest/screenshots/screen8.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 200) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      memoquest9: file(
        relativePath: { eq: "memoquest/screenshots/screen9.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 200) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      ldvelh1: file(relativePath: { eq: "ldvelh/screenshots/screen1.png" }) {
        childImageSharp {
          fluid(maxWidth: 200) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      ldvelh2: file(relativePath: { eq: "ldvelh/screenshots/screen2.png" }) {
        childImageSharp {
          fluid(maxWidth: 200) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      ldvelh3: file(relativePath: { eq: "ldvelh/screenshots/screen3.png" }) {
        childImageSharp {
          fluid(maxWidth: 200) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      ldvelh4: file(relativePath: { eq: "ldvelh/screenshots/screen4.png" }) {
        childImageSharp {
          fluid(maxWidth: 200) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      ldvelh5: file(relativePath: { eq: "ldvelh/screenshots/screen5.png" }) {
        childImageSharp {
          fluid(maxWidth: 200) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  return <Img {...props} fluid={data[`${gameId}${id}`].childImageSharp.fluid} />
}

export default Screenshot
